import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { heapTrack } from "lib/analytics";
import { LANGUAGE_SELECT_OPTIONS, LANGUAGE_SOURCE } from "lib/constants";
import { hireShape } from "lib/propTypes";
import LanguageSelector from "common/LanguageSelector";
import { usePatch } from "redux/fetch-hooks";
import { setUserLanguage } from "redux/ws/actions";
import { getUserLanguage } from "redux/ws/selectors";

const CheckInLanguageSelector = ({ hire }) => {
    const dispatch = useDispatch();
    const userLanguage = useSelector(getUserLanguage);
    const supportedLanguages = useSelector((state) =>
        LANGUAGE_SELECT_OPTIONS.filter(
            (o) => o.value === "en" || !!state.questions.questions.some((q) => q[o.value]),
        ),
    );

    const [patchLanguage] = usePatch(`/api/v1/user-language/${hire.user_id}/`);

    useEffect(() => {
        // If we don't have a preferred language set, set it to the value given
        // by the browser currently
        if (!userLanguage) {
            // Example: en-US
            // See: https://datatracker.ietf.org/doc/html/rfc5646
            patchLanguage({
                data: {
                    language: navigator.language,
                    source: LANGUAGE_SOURCE.BROWSER,
                },
            });
        }
    }, []);

    const onChangeLanguage = ({ value }) => {
        dispatch(setUserLanguage(value));
        heapTrack("Checkin Language Selected", { language: value });

        patchLanguage({
            data: {
                language: value,
                source: LANGUAGE_SOURCE.USER,
            },
        });
    };

    return (
        <LanguageSelector
            selectedLanguage={userLanguage}
            onChange={onChangeLanguage}
            supportedLanguages={supportedLanguages}
        />
    );
};

CheckInLanguageSelector.propTypes = {
    hire: hireShape.isRequired,
};

export default React.memo(CheckInLanguageSelector);
